import { app } from "../main";

export let fileUploadValidation = (event) => {
  let assets = [...event.target.files];
  let warningMsg = "";
  let fileMaxSize5MB = 15000000;
  let availableTypes = ["application/pdf", "image/jpeg", "image/png"];
  let files = [];

  if (assets.length) {
    for (let file of assets) {
      if (!availableTypes.includes(file.type) || file.size > fileMaxSize5MB) {
        warningMsg = `الملفات المسموح بها فقط JPG, JPEG, PNG, PDF
  ولا يمكن رفع ملفات اكبر من 15 ميجا`;
        alertMessage(warningMsg);
      } else {
        files.push(file);
      }
    }
  }
  return files;
};

let alertMessage = (text) => {
  app.$bvToast.toast(`${text}`, {
    title: "ملحوظة",
    autoHideDelay: 5000,
    variant: "danger",
    solid: true,
  });
};
